import { wagerAtoms } from './wagerAtoms';
var focusWager = function () {
    var _a;
    (_a = wagerAtoms.wagerElement.getValue()) === null || _a === void 0 ? void 0 : _a.focus();
};
export { focusWager };
